import Home from "../Home";

import EnvelopTrigger from "../Envelops/EnvelopTrigger";
import SignatureQC from "../Envelops/SignatureQC";

import HotelManager from "../HotelManager";
import HotelReview from "../HotelReviews/HotelReview";
import MainRolesManager from "../MainRoles/MainRolesManager";
import HotelsGroupsManager from "../HotelsGroups/HotelsGroupsManager";
import HotelsGroupCreate from "../HotelsGroups/HotelsGroupCreate";
import LoggedUserDetails from "../LoggedUserDetails";
import UserGrouping from "../UserGrouping";
import UserAppConfigManager from "../AppConfig/UserAppConfigManager";
import RoleAppConfigManager from "../AppConfig/RoleAppConfigManager";
import UserInvitation from "../Users/UserInvitation";
import UserManager from "../Users/UserManager";
import AdvanceSearchUser from "../AdvanceSearch/User";

import HotelCreate from "../Hotels/HotelCreate";
import CreateIndexes from "../Indexes/CreateIndexes";
import IndexView from "../Indexes/IndexView";
import IndexMapping from "../Indexes/IndexMapping";
// import UserCreate from "./Users/UserCreate";
import UserCreateAndUpdate from "../Users/UserCreateAndUpdate";
import BulkUserCreation from "../BulkCreation/BulkUserCreation";
import PmsManager from "../Pms/PmsManager";
import PmsCreate from "../Pms/PmsCreate";
import BulkHotelCreation from "../BulkCreation/BulkHotelCreation";
import EnvironmentImpact from "../Envelops/EnvironmentImpact";
import Notifications from "../Notifications/Notifications";
import CreateBulkFileMapping from "../BulkFileMapping/CreateBulkFileMapping";
import ViewBulkFileMapping from "../BulkFileMapping/ViewBulkFileMapping";

import BulkReportDelete from "../ReportManagement/BulkReportDelete";
import ReportQc from "../ReportManagement/ReportQc";
import HotelQc from "../HotelQc/HotelQc";

import HmgCreate from "../HmgCreate";
import HmgManager from "../HmgManager";
import HmgMainCreate from "../HmgMain/HmgMainCreate";
import HmgMainManager from "../HmgMain/HmgMainManager";
import AppClickedStatistics from "../Statistics/AppClickedStatistics";

import AppConfiguration from "../Project/AppConfiguration";
// Default Permissions
import DefaultPermissions from "../Applications/DefaultConfigs/DefaultPermissions";
// Default Index Settings
import DefaultIndexSettings from "../Applications/DefaultIndexSettings/DefaultIndexSettings";
// Default Index Order Settings
import DefaultIndexOrderSettings from "../Applications/DefaultIndexOrderSettings/DefaultIndexOrderSettings";
import UserDetail from "../Users/UserDetail";

// import BarcodeUpload from "../FileUpload/BarcodeUpload";
// import TrainingMaterialUpload from "../FileUpload/TrainingMaterialUpload";
import Faqs from "../FileUpload/Faqs";
// sftp app - old
import ManualJobExecutionForm from "../SftpUI/ManualJobExecution";

// sftp app New Paths
import JobConfigView from "../SftpUI/JobConfigView";
import SFTPConnectionView from "../SftpUI/ConnectionConfigView";
import SFTPLog from "../SftpUI/Log";
import ConnectionConfigurationForm from "../SftpUI/ConnectionConfiguration";
import AutomatedJobsConfigurationForm from "../SftpUI/AutomatedJobsConfigurationForm";

// NotificationSchedules
import Reminders from "../NotificationSchedules/Reminders";
import HMGRoleMapping from "../RoleManagement/HMGRoleMapping";

// UserPermission
import UserPermission from "../UserPermission/UserPermission";
// RoleManager
import RoleManager from "../RoleManager/RoleManager";
import SecondaryEnvelope from "../SecondaryEnvelope/SecondaryEnvelope";

// sample template
import SampleTemplate from "../SampleTemplate/SampleTemplate";

//PMS report
import ViewPMSReportList from "../Pms/ReportList/ViewPMSReportList";
// report category
import AddReportCategory from "../ReportCategory/AddReportCategory";
import BulkReportCategoryUpdate from "../ReportCategory/BulkReportCategoryUpdate";
import ViewReportCategory from "../ReportCategory/ViewReportCategory";
// report management
import ViewReports from "../ReportManagement/ViewReports";
import BulkReportUpdateHome from "../ReportManagement/BulkReportUpdateHome";
import BulkReportUpdate from "../ReportManagement/BulkReportUpdate";
import PMSReportsView from "../../components/Report/PMSReportsView";
import AdditionalReports from "../ReportManagement/AdditionalReports";

// SSO Integration
import SSOIntegration from "../Users/SSOIntegration";

//MDO Self Service sales team
import OnboardigHandler from "../Onboarding/OnboardingHandler";
import OnboardingCustomerManager from "../Onboarding/OnboardingCustomer/OnboardingCustomerManager";
import OnboardingProperties from "../Onboarding/OnboardingProperties/OnboardingProperties";
import OnboardingUsers from "../Onboarding/OnboardingUsers/OnboardingUsers";

//MDO Self Service coporate contact
import CorpContactApprover from "../Onboarding/CorporateContact/CustomerApprover/CorpContactApprover";// TODO: to be removed
import CustomerContainer from "../Onboarding/CorporateContact/CustomerApprover/CustomerContainer";
import CorpContactPropertyEditor from "../Onboarding/CorporateContact/PropertyEditor/CorpContactPropertyEditor";
import CorpContactPropertyUsers from "../Onboarding/CorporateContact/PropertyUsers/CorpContactPropertyUsers";
import CorpContactCustomerEditor from "../Onboarding/CorporateContact/CustomerEditor/CorpContactCustomerEditor";

//MDO Self Service property contact
import PropContactPropertyApprover from "../Onboarding/PropertyContact/PropertyApprover/PropContactPropertyApprover";
import PropContactPropertyEditor from "../Onboarding/PropertyContact/PropertyEditor/PropContactPropertyEditor";
import AddProperty from "../Onboarding/CorporateContact/AddProperty/AddProperty";
import PropertyContainer from "../Onboarding/CorporateContact/CustomerApprover/PropertyContainer";

const routes = [
  {
    permission: ["sm_report_category"],
    accessRoutes: [
      {
        path: "/report-category/add",
        component: AddReportCategory,
        exact: true,
      },
      {
        path: "/report-category/view",
        component: ViewReportCategory,
        exact: false,
      },
      {
        path: "/report-category/edit",
        component: BulkReportCategoryUpdate,
        exact: true,
      },
    ],
  },
  {
    permission: ["sm_report_management"],
    accessRoutes: [
      {
        path: "/report-management/view",
        component: ViewReports,
        exact: true,
      },
      {
        path: "/report-management/bulk",
        component: BulkReportUpdateHome,
        exact: true,
      },
      {
        path: "/report-management/bulk/edit",
        component: BulkReportUpdate,
        exact: true,
      },
      {
        path: "/report-management/copy-over/:projectId/:pmsId/:hotelId",
        component: PMSReportsView,
        exact: true,
      },
      {
        path: "/report-management/additional-reports",
        component: AdditionalReports,
        exact: true,
      },
    ],
  },
  // {
  //   permission: ["sm_barcode_management"],
  //   accessRoutes: [
  //     {
  //       path: "/barcode-management",
  //       component: BarcodeUpload,
  //       exact: false,
  //     },
  //   ],
  // },
  {
    permission: ["sm_onboarding_automation"],
    accessRoutes: [
      {
        path: "/onboarding/dashboard",
        component: OnboardigHandler,
        exact: false,
      },
      {
        path: "/onboarding/customer/add",
        component: OnboardingCustomerManager,
        elementParams: {
          operation: "add",
        },
        exact: false,
      },
      {
        path: "/onboarding/customer/edit",
        component: OnboardingCustomerManager,
        elementParams: {
          operation: "edit",
        },
        exact: false,
      },
      {
        path: "/onboarding/properties",
        component: OnboardingProperties,
        exact: false,
      },
      {
        path: "/onboarding/users",
        component: OnboardingUsers,
        exact: false,
      },
      {
        path: "/onboarding/customers/:id/approve",
        component: CustomerContainer,
        exact: false,
      },
      {
        path: "/onboarding/customers/:id/approve-property",
        component: PropertyContainer,
        exact: false,
      },
      {
        path: "/onboarding/corp-contact/properties/edit",
        component: CorpContactPropertyEditor,
        elementParams: {
          operation: "edit",
        },
        exact: false,
      },
      {
        path: "/onboarding/corp-contact/properties/add",
        component: AddProperty,
        exact: false,
      },
      {
        path: "/onboarding/corp-contact/property/users",
        component: CorpContactPropertyUsers,
        exact: false,
      },
      {
        path: "/onboarding/corp-contact/customer/edit",
        component: CorpContactCustomerEditor,
        elementParams: {
          operation: "edit",
        },
        exact: false,
      },
      {
        path: "/onboarding/prop-contact/property/approve",
        component: PropContactPropertyApprover,
        elementParams: {
          operation: "approve",
        },
        exact: false,
      },
      {
        path: "/onboarding/prop-contact/property/edit",
        component: PropContactPropertyEditor,
        elementParams: {
          operation: "approve",
        },
        exact: false,
      },
    ],
  },
  {
    permission: ["sm_end_user_access"],
    accessRoutes: [
      {
        path: "/",
        component: Home,
        exact: true,
        permisson: "",
      },
      {
        path: "/user-manager",
        component: UserManager,
        exact: false,
      },
      {
        path: "/user-invitation",
        component: UserInvitation,
        exact: false,
        permission: ["sm_end_user_access"],
      },
      {
        path: "/user-create/:id",
        component: UserCreateAndUpdate,
        exact: false,
      },
      {
        path: "/user-create",
        component: UserCreateAndUpdate,
        exact: false,
      },
      {
        path: "/bulk-user-creation",
        component: BulkUserCreation,
        exact: false,
      },
      {
        path: "/advance-search/user",
        component: AdvanceSearchUser,
        exact: false,
      },
      {
        path: "/user-permission",
        component: UserPermission,
        exact: false,
      },
      {
        path: "/user/detail/:user_id",
        component: UserDetail,
        exact: false,
      },
    ],
  },
  {
    permission: ["sm_solution_access"],
    accessRoutes: [
      {
        path: "/hotel-manager",
        component: HotelManager,
        exact: false,
      },
      {
        path: "/envelop-trigger",
        component: EnvelopTrigger,
        exact: false,
      },
      {
        path: "/signature-qc",
        component: SignatureQC,
        exact: false,
      },
      {
        path: "/environ-impact",
        component: EnvironmentImpact,
        exact: false,
      },
      {
        path: "/notifications",
        component: Notifications,
        exact: false,
      },
      {
        path: "/main-roles-manager",
        component: MainRolesManager,
        exact: false,
      },
      {
        path: "/role-manager",
        component: RoleManager,
        exact: false,
      },
      {
        path: "/hotels-groups-manager",
        component: HotelsGroupsManager,
        exact: false,
      },
      {
        path: "/envelop-trigger",
        component: EnvelopTrigger,
        exact: false,
      },
      {
        path: "/hotels-group-create",
        component: HotelsGroupCreate,
        exact: false,
      },
      {
        path: "/logged_user_details",
        component: LoggedUserDetails,
        exact: false,
      },
      {
        path: "/user-app-config-manager",
        component: UserAppConfigManager,
        exact: false,
      },
      {
        path: "/role-app-config-manager",
        component: RoleAppConfigManager,
        exact: false,
      },
      {
        path: "/sso-integration",
        component: SSOIntegration,
        exact: false,
      },
      {
        path: "/envelope-signers",
        component: UserGrouping,
        exact: false,
      },
      {
        path: "/hotel-create",
        component: HotelCreate,
        exact: false,
      },
      {
        path: "/pms-manager",
        component: PmsManager,
        exact: false,
      },
      {
        path: "/pms-create",
        component: PmsCreate,
        exact: false,
      },
      {
        path: "/pms/report-list",
        component: ViewPMSReportList,
        exact: false,
      },
      {
        path: "/bulk-hotel-creation",
        component: BulkHotelCreation,
        exact: false,
      },
      {
        path: "/project-manager",
        component: HmgManager,
        exact: false,
      },

      {
        path: "/project-create",
        component: HmgCreate,
        exact: false,
      },
      {
        path: "/hmg-role-mapping",
        component: HMGRoleMapping,
        exact: false,
      },
      {
        path: "/applications/default",
        component: DefaultPermissions,
        exact: false,
      },
      {
        path: "/applications/default-index-settings",
        component: DefaultIndexSettings,
        exact: false,
      },
      {
        path: "/applications/default-index-order-settings",
        component: DefaultIndexOrderSettings,
        exact: false,
      },
      {
        path: "/app-configuration",
        component: AppConfiguration,
        exact: false,
      },
      {
        path: "/hmg-create",
        component: HmgMainCreate,
        exact: false,
      },
      {
        path: "/hmg-manager",
        component: HmgMainManager,
        exact: false,
      },
      {
        path: "/statistics/app-clicked-statistics",
        component: AppClickedStatistics,
        exact: false,
      },

      {
        path: "/hotel-reviews/facebook-page",
        component: HotelReview,
        elementParams: {
          path: "hotel-reviews/facebook-page",
          key: "facebook",
          label: "Facebook Page",
          dataIndex: "facebook_page_url",
          tableTitle: "Facebook Page URL",
        },
        exact: false,
      },
      {
        path: "/hotel-reviews/google-place",
        component: HotelReview,
        elementParams: {
          path: "/hotel-reviews/google-place",
          key: "google",
          label: "Google Place",
          dataIndex: "google_place_id",
          tableTitle: "Google Place",
        },
        exact: false,
      },
      {
        path: "/hotel-reviews/trip-advisor",
        component: HotelReview,
        elementParams: {
          path: "/hotel-reviews/trip-advisor",
          key: "tripadvisor",
          label: "TripAdvisor",
          dataIndex: "tripAdvisor_location_id",
          tableTitle: "TripAdvisor",
        },
        exact: false,
      },
      {
        path: "/hotel-reviews/yelp-page",
        component: HotelReview,
        elementParams: {
          path: "/hotel-reviews/yelp-page",
          key: "yelp",
          label: "Yelp Page",
          dataIndex: "yelp_business_id",
          tableTitle: "Yelp Page",
        },
        exact: false,
      },
      {
        path: "/report-management/report-qc",
        component: ReportQc,
        exact: false,
      },
      {
        path: "/report-management/hotel-qc",
        component: HotelQc,
        exact: false,
      },
      {
        path: "/report-management/bulk-delete",
        component: BulkReportDelete,
        exact: false,
      },
      {
        path: "/index/create",
        component: CreateIndexes,
        exact: false,
      },
      {
        path: "/index/view",
        component: IndexView,
        exact: false,
      },
      {
        path: "/index/mapping",
        component: IndexMapping,
        exact: false,
      },
      {
        path: "/bulkfilemapping/create",
        component: CreateBulkFileMapping,
        exact: false,
      },
      {
        path: "/bulkfilemapping/view",
        component: ViewBulkFileMapping,
        exact: false,
      },
      // {
      //   path: "/file-upload/barcode-upload",
      //   component: BarcodeUpload,
      //   exact: false,
      // },
      // {
      //   path: "/file-upload/trainingm-upload",
      //   component: TrainingMaterialUpload,
      //   exact: false,
      // },
      {
        path: "/file-upload/faqs",
        component: Faqs,
        exact: false,
      },
      {
        path: "/file-transfer/connection-configuration-form",
        component: ConnectionConfigurationForm,
        exact: false,
      },
      {
        path: "/file-transfer/sftp-log",
        component: SFTPLog,
        exact: false,
      },
      {
        path: "/file-transfer/sftp-job-view",
        component: JobConfigView,
        exact: false,
      },
      {
        path: "/file-transfer/sftp-connections-view",
        component: SFTPConnectionView,
        exact: false,
      },
      {
        path: "/file-transfer/automated-job-configuration-form",
        component: AutomatedJobsConfigurationForm,
        exact: false,
      },

      {
        path: "/file-transfer/manual-job-execution-form",
        component: ManualJobExecutionForm,
        exact: false,
      },
      {
        path: "/notification-schedules/reminders",
        component: Reminders,
        exact: false,
      },
      {
        path: "/sample-template",
        component: SampleTemplate,
        exact: false,
      },
    ],
  },
];

// Marriott only route
if (process.env.REACT_APP_PLATFORM_TYPE === "MARRIOTT") {
  const adminUserRoutes = routes.find((route) =>
    route.permission.includes("sm_solution_access"),
  );

  adminUserRoutes.accessRoutes.push({
    path: "/secondary-envelope",
    component: SecondaryEnvelope,
    exact: false,
  });
}
export default routes;
